/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
import React from 'react';
import { Button, InputNumber, Select } from 'antd';
import PropTypes from 'prop-types';
import trashCan from '../../images/trashcan.svg';

const { Option } = Select;

const MinMax = ({ panels, setPanels, pIdx, idx, item, selectors, name, onChange }) => {
  const updatePanels = () => {
    setPanels([...panels]);
  }
  const setDimension = dim => {
    console.log('MinMax - setDimension called with:', dim);
    item.dimension = dim;
    if (item.value !== null) {
      sortItemsAndUpdate();
    } else {
      updatePanels();
    }
  }

  const setValue = val => {
    console.log('MinMax - setValue called with:', val);
    item.value = val;
    updatePanels();
  }

  const addItem = () => {
    panels[pIdx].items.push({ dimension: null, value: null });
    sortItems();
    updatePanels();
  }

  const sortItems = () => {
    const rank = dim => selectors.indexOf(dim);
    panels[pIdx].items.sort((a, b) => {
      if (!a.dimension) {
        if (!b.dimension) {
          return 0;
        }
        return 1;
      } else if (!b.dimension) {
        return -1;
      }
      return rank(a.dimension) - rank(b.dimension);
      // return a.dimension.localeCompare(b.dimension);
    })
  }

  const sortItemsAndUpdate = () => {
    sortItems();
    updatePanels();
    onChange();
  }

  const deleteItem = () => {
    panels[pIdx].items.splice(idx, 1);
    if (panels[pIdx].items.length === 0) {
      panels.splice(pIdx, 1);
    }
    updatePanels();
    onChange();
  }

  const usedOption = (option => {
    const found = panels[pIdx].items.find(itm => itm.dimension === option);
    if (found) {
      return true;
    }
    if (name === 'Odmaxw' && option.includes('Min')) {
      return true;
    }
    if (option.includes("Tons")) {
      return !name.includes("Press");
    }
    return name.includes("Press");
  });

  const lastItem = () => {
    const z = panels[pIdx].items.length;
    return idx === z - 1;
  }

  const isNotFinished = () => item.dimension === null || item.value === null;

  const selectFilters = selectors.filter(option => !usedOption(option));
  if (selectFilters.length === 1 && item.dimension === null && item.value === null) {
    item.dimension = selectFilters[0];
  }
  return (
    <tr>
      <td>
        <Select
          placeholder="dimension"
          value={item.dimension}
          onSelect={dim => setDimension(dim)}
        >
          {selectFilters.map(option => (
            <Option value={option} disabled={!option} key={option}>{option || "----"}</Option>
          ))}
        </Select>
      </td>
      <td>
        <InputNumber
          placeholder="value"
          value={item.value}
          onChange={v => { setValue(v) }}
          onBlur={sortItemsAndUpdate}
          maxLength={10}
        />
      </td>
      <td>
        <Button onClick={deleteItem} tabIndex={-1}>
          <img
            className="nf-loading__img"
            src={trashCan}
            alt="Delete"
          />
        </Button>
      </td>
      <td>
        <Button hidden={isNotFinished() || selectors.filter(selector => !usedOption(selector)).length === 0 || !lastItem()} onClick={addItem}>
          Add
        </Button>
      </td>
    </tr>
  );
}

MinMax.propTypes = {
  panels: PropTypes.object.isRequired,
  setPanels: PropTypes.func.isRequired,
  pIdx: PropTypes.number.isRequired,
  idx: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  selectors: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MinMax



// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/MinMax.jsx